import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { DataProvider } from '../../providers/data/data';
import { RestProvider } from '../../providers/rest/rest';
import { UploadPage } from '../upload/upload';
import { ViewerPage } from '../viewer/viewer';

/**
 * Generated class for the HomePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-home',
  templateUrl: 'home.html',
})
export class HomePage {

  accessToken = '';

  constructor(public navCtrl: NavController, public navParams: NavParams, 
    private data: DataProvider,
    private rest: RestProvider) {
  }

  ionViewDidLoad() {
    document.getElementById('mainMenu').style.display = 'block';
    this.data.menu = true;
    this.rest.getAccessToken('home')
    .subscribe((res) => {
      let result = JSON.parse(JSON.stringify(res));
      /*if(!localStorage.getItem('urn')) {
        this.navCtrl.push(UploadPage);
      } else {
        this.navCtrl.push(ViewerPage);
      }*/
      if (result.access_token !== "") {
        localStorage.setItem("accessToken", result.access_token);
        this.accessToken = result.access_token;
        // console.log(this.accessToken);
        this.rest.setAccessTokenNow(this.accessToken);
        this.rest.getBuckets().subscribe(buckets => {
          let result = JSON.parse(JSON.stringify(buckets)).items;
          if(result.length > 0) {
            // localStorage.setItem('urn', localStorage.getItem('bucket-' + result[result.length - 1].bucketKey));
            // if(!localStorage.getItem('bucket-' + result[result.length - 1].bucketKey)) {
            if(!localStorage.getItem('urn')) {
              this.navCtrl.push(UploadPage);
            } else {
              this.navCtrl.push(ViewerPage);
            }
          } else {
            this.navCtrl.push(UploadPage);
          }
        });        
      }
    });    
  }

  toUpload(){
    /*this.rest.createBucket();
    if(!localStorage.getItem('urn')) {
      this.navCtrl.push(UploadPage);
    } else {
      this.navCtrl.push(ViewerPage);
    }*/
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts